import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { useSettingsContext } from "../Settings/hooks/useSettingsContext";
import Table from "../Invoices/Table/Table";
import VirtualBatteryDownload from "./VirtualBatteryDownload";
import VirtualBatteryDiscountToggle from "./VirtualBatteryDiscountToggle";
import VirtualBatteryDiscountSelect from "./VirtualBatteryDiscountSelect";
import ChangePercentageVirtualBatteryDialogOpenButton from './ChangePercentageVirtualBattery/ChangePercentageVirtualBatteryDialogOpenButton';
import BateriaVirtualMoveVirtualBatteryDialogOpenButton from './MoveVirtualBattery/MoveVirtualBatteryDialogOpenButton';
import { RootState } from "@/store";
import { IStyles } from './types/styles';
import { IBateriaVirtual } from './types/bateriaVirtual';
import { updateVirtualBatteryTypes } from "@/actions/bateriaVirtual";
import { Card, CardHeader, CardContent } from "@mui/material";

export interface VirtualBatteryCardListProps {
  styles: IStyles
}


const VirtualBatteryCardList = ({ 
  styles 
}: VirtualBatteryCardListProps) => {
  
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const Settings = useSettingsContext()

  const contract = useSelector((state: RootState) => state.contracts.view_contract);
  const contracts = useSelector((state: RootState) => state.contracts);
  const [ nContracts, setNContracts ] = useState(false);
  const [ otherContractBatteries, setOtherContractBatteries ] = useState(false);

  const handleBatteryModeChange = (value: string, bateriaId: number) => {
    dispatch(updateVirtualBatteryTypes(value, bateriaId));
  }

  function showChangePercentageVirtualBattery(bateriaVirtual: IBateriaVirtual) {
    let res = false;

    let nContracts = 0;
    for (let i = 0; i < contracts.items.length; i++) {
      for (let j = 0; j < contracts.items[i].bateria_virtual.length; j++){
        if (bateriaVirtual.bateria.id == contracts.items[i].bateria_virtual[j].bateria.id){
          nContracts++;
        }
      }
    }

    if(nContracts > 1){
      res = true
    }

    return res;
  }

  function showBateriaVirtualMoveVirtualBattery(bateriaVirtual: IBateriaVirtual) {
    let res = false;

    let otherContractBatteries = 0;
    for (let i=0; i < contracts.items.length; i++){
      for (let j=0; j < contracts.items[i].bateria_virtual.length; j++){
        if (contracts.items[i].bateria_virtual[j].bateria.id != bateriaVirtual.bateria.id
          && contracts.items[i].bateria_virtual[j].bateria.name != bateriaVirtual.bateria.name
          && contracts.items[i].id != contract
          ){
            otherContractBatteries++;
        }
      }
    }

    if(otherContractBatteries > 1){
      res = true
    }

    return res;
  }

  const columns = [
    {
      title: t('common:text.altHome_battery'),
      key: "name",
      computeValue: (bateriaVirtual: IBateriaVirtual) => bateriaVirtual.bateria.name
    }, {
      title: t('common:text.altHome_accumulated'),
      key: "total_desc",
      computeValue: (bateriaVirtual: IBateriaVirtual) => bateriaVirtual.total_descompte
    }, {
      title: t('common:text.virtual_battery_percentage'),
      key: "percentatge",
      computeValue: (bateriaVirtual: IBateriaVirtual) => bateriaVirtual.pes_percentatge
    }, {
      title: t('common:text.altHome_to_discount'),
      key: "gestio_desc",
      computeValue: (bateriaVirtual: IBateriaVirtual) => <>
        {Settings?.contract?.virtualBattery?.renderType === "toggle" ?
          <VirtualBatteryDiscountToggle 
            bateriaVirtual={bateriaVirtual}
            handleBatteryModeChange={handleBatteryModeChange}
          />
          
          :
          
          <VirtualBatteryDiscountSelect 
            bateriaVirtual={bateriaVirtual}
            handleBatteryModeChange={handleBatteryModeChange}
          />
        }
      </>
    }, {
      title: '',
      key: "percentatge1",
      computeValue: (bateriaVirtual: IBateriaVirtual) => <>
        {showChangePercentageVirtualBattery(bateriaVirtual) &&
          <ChangePercentageVirtualBatteryDialogOpenButton bateriaVirtual={bateriaVirtual} />
        }
      </>
    }, {
      title: '',
      key: "percentatge2",
      computeValue: (bateriaVirtual: IBateriaVirtual) => <>
        {showBateriaVirtualMoveVirtualBattery(bateriaVirtual) &&
          <BateriaVirtualMoveVirtualBatteryDialogOpenButton bateriaVirtual={bateriaVirtual} />
        }
      </>
    }
  ];

  return (
    <>
    
      <Card style={styles.entry}>
        <CardHeader title={ t("common:text.altHome_virtual_battery") } style={{flexGrow: 1}}/>

        <VirtualBatteryDownload bateries={contract.bateria_virtual} />
        
        <CardContent>
          <Table
            columns={columns}
            loaded={true}
            data={contract.bateria_virtual}
            onRowStatus={null}
          />
        </CardContent>
      </Card>

    </>
  )
}

export default VirtualBatteryCardList